import React, { useCallback, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import useVehicleCheck from './useVehicleCheck';
import VehicleCheckEntry from './VehicleCheckEntry';
import VehicleCheckDialog from './VehicleCheckDialog';
import VehicleCheckGate from './VehicleCheckGate';
import consultDraft from './consultDraft';
import { openChatWithDraft } from '../chat/chatBus';

// 진입 카드(물음표·문구·고객 질문 전광판) + 모달 묶음 — 접수 화면 물품 목록 아래에 둔다. 회원 전용(기업·개인): 비회원은 로그인·회원가입 안내.
// 결과는 조회용이며 접수 폼을 바꾸지 않는다. 폼의 출발·도착이 있으면 차량별 예상 운임·시간을 함께 보여 주고, [이 내용으로 상담하기]는 실시간문의에 초안을 넣어 연다
function VehicleCheck({ dense = false, className, loginStore, qsStore }) {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [gate, setGate] = useState(false);
  const member = Boolean(loginStore.userInfo && loginStore.userInfo.userKey);

  const getContext = useCallback(() => {
    const o = qsStore.options || {};
    return { startAddr: o.startAddr, startPointCode: o.startPointCode, endAddr: o.endAddr, endPointCode: o.endPointCode, route: o.route, isExpress: o.isExpress || 'N' };
  }, [qsStore]);
  const check = useVehicleCheck({ getContext });

  const onEntry = () => (member ? setOpen(true) : setGate(true));
  const onConsult = (result, compare) => { setOpen(false); openChatWithDraft(consultDraft(result, compare)); };

  return (
    <React.Fragment>
      <VehicleCheckEntry dense={dense} className={className} onClick={onEntry} />
      <VehicleCheckDialog open={open} onClose={() => setOpen(false)} onConsult={onConsult} check={check} />
      <VehicleCheckGate open={gate} onClose={() => setGate(false)} onLogin={() => history.push('/login')} onJoin={() => history.push('/signup')} />
    </React.Fragment>
  );
}

export default inject('loginStore', 'qsStore')(observer(VehicleCheck));
